import "./svg/leaf-4.svg"

export default {
    name: "leaf-4",
    viewBox: "100 30",
}
